import Axios from 'axios';

const axios = Axios.create({
  baseURL:  `${ window.location.origin }/api`, // Your API base URL
  // baseURL:  `${ window.location.origin.replace(3000, 5000) }/api`, // Your API base URL
  timeout: 10000, // Request timeout in milliseconds
  headers: {
    'Content-Type': 'application/json',
    'authorization': `Bearer ${ localStorage?.token }`
    // other common headers can be set here
  },
});

export default axios;